module.exports = {"511504001":"柏溪街道","511504002":"南岸街道","511504003":"赵场街道","511504101":"南广镇","511504103":"观音镇","511504104":"横江镇","511504105":"柳嘉镇","511504106":"泥溪镇","511504107":"蕨溪镇","511504108":"商州镇","511504109":"高场镇","511504110":"安边镇","511504111":"双龙镇","511504113":"合什镇","511504119":"樟海镇","511504202":"龙池乡","511504203":"凤仪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511504.json
// module id = 2488
// module chunks = 0